const isProd = Boolean(process.env.REACT_APP_BE_HOST);
export const BASE_BE_URL = process.env.REACT_APP_BE_HOST || '';
export const BASE_API_URL = `${BASE_BE_URL}/api/v1`;
export const STATIC_URL = `${BASE_BE_URL}/images`;
export const COVER_URL = `/chimerasCover.svg`;

export const TOKEN_NAME = 'chimeras_token'

export const MAX_VISIBLE_ISSUES = 3;

export const DEFAULT_TITLE = 'Химеры';